import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, PermissionFlag } from './auth.service';

/** Protects the editor according to the operation requested by its query parameters. */
export const mindmapPermissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isNewMindMap = route.queryParamMap.get('new') === '1';
  const permission = isNewMindMap ? PermissionFlag.Create : PermissionFlag.Read;

  if (authService.hasPermission('Mindmap', permission)) {
    return true;
  }

  return router.createUrlTree(['/mindmap'], {
    queryParams: { mindmapAccessDenied: 1 },
  });
};
